import React, { useEffect, useRef } from 'react';
import { ZegoUIKitPrebuilt } from '@zegocloud/zego-uikit-prebuilt';

export const ZegoLiveStream = ({ communityId, user, isOwner }) => {
  const containerRef = useRef(null);
  const zpRef = useRef(null);

  useEffect(() => {
    let isMounted = true;
    
    const initZego = async () => {
      const appID = Number(process.env.REACT_APP_ZEGO_APP_ID || 54392117);
      const serverSecret = process.env.REACT_APP_ZEGO_SERVER_SECRET || "87fe563980e80bcde722a555c879413d";
      
      const userID = String(user?._id || `guest_${Math.floor(Math.random() * 10000)}`);
      const userName = String(user?.full_name || user?.name || "Student");
      const roomID = String(communityId);
      
      const kitToken = ZegoUIKitPrebuilt.generateKitTokenForTest(
        appID, 
        serverSecret, 
        roomID, 
        userID, 
        userName
      );
      
      console.log('Zego Initialization:', {
        appID,
        serverSecret: serverSecret ? 'PRESENT' : 'MISSING',
        communityId,
        userID,
        userName
      });

      const zp = ZegoUIKitPrebuilt.create(kitToken);
      zpRef.current = zp;

      if (isMounted && containerRef.current) {
        zp.joinRoom({
          container: containerRef.current,
          scenario: {
            mode: ZegoUIKitPrebuilt.LiveStreaming,
            config: {
              role: isOwner ? ZegoUIKitPrebuilt.Host : ZegoUIKitPrebuilt.Audience,
            },
          },
          showPreJoinView: false,
          turnOnMicrophoneWhenJoining: isOwner,
          turnOnCameraWhenJoining: isOwner,
          showMyCameraToggleButton: isOwner,
          showMyMicrophoneToggleButton: isOwner,
          showAudioVideoSettingsButton: isOwner,
          showScreenSharingButton: isOwner,
        });
      }
    };

    initZego();

    return () => {
      isMounted = false;
      if (zpRef.current) {
        zpRef.current.destroy();
      }
    };
  }, [communityId, user, isOwner]);

  return (
    <div 
      className="zego-live-container w-100 bg-dark rounded-4 overflow-hidden shadow-sm" 
      style={{ height: '600px', position: 'relative' }} 
      ref={containerRef}
    >
    </div>
  );
};
